import React, { useEffect } from "react";
import TableLayout from "components/Forms/TableLayout/TableLayout";
import { useAppDispatch, useAppSelector } from "app/hooks";
import withAuth from "lib/hoc/withAuth";
import { useLocation } from "react-router-dom";
import Table from "ui/organisms/Table";
import { fileDetailColumns } from "./components/columns";
import { fileDetailGridMapper } from "lib/helpers/reportsHelper";
import { getDetailsExcelFilesLog } from "app/features/personSlice";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Chip from "ui/molecules/Chip";

const FileDetail = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const codeUp = queryParams.get("codeUp") ?? "";
  const excelFileName = queryParams.get("excelFileName") ?? "";
  const { fileDetail, fileLoading } = useAppSelector((state) => state.person);

  useEffect(() => {
    dispatch(getDetailsExcelFilesLog({ codeUp, excelFileName }));
  }, []);

  return (
    <TableLayout maxWidthCard={1600} maxWidthContainer='xl' title='Detalle del Archivo'>
      <Chip
        link='/survey/file-history'
        label='Volver'
        color='primary'
        backgroundColor='#4e5559'
        hoverTextColor='white'
        icon={<ArrowBackIcon />}
        hoverBackgroundColor='#727b81'
      />
      <Table
        isLoading={fileLoading}
        dataGridColumns={fileDetailColumns}
        rows={fileDetailGridMapper(fileDetail)}
        fileName='detalle'
      />
    </TableLayout>
  );
};

export default withAuth(FileDetail);
